import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-verify',
  templateUrl: './job-verify.component.html',
  styleUrls: ['./job-verify.component.less']
})
export class JobVerifyComponent implements OnInit {

  verifyDesc = '';
  constructor() { }

  ngOnInit(): void {
  }

}
